import React from 'react';
import PropTypes from 'prop-types';

LastImportedAtDate.propTypes = {
    date: PropTypes.string
};

function LastImportedAtDate({date}) {
    if (!date) {
        return null;
    }

    const newDate = new Date(date);

    const formatter = new Intl.DateTimeFormat('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });

    const formatted = formatter.format(newDate);

    return (
        <div style={{color: '#6B7280'}}>
            {formatted}
        </div>
    )
}

export default LastImportedAtDate;
